import { render, staticRenderFns } from "./ProjectsSection.vue?vue&type=template&id=bc592c10&scoped=true"
import script from "./ProjectsSection.vue?vue&type=script&lang=js"
export * from "./ProjectsSection.vue?vue&type=script&lang=js"
import style0 from "./ProjectsSection.vue?vue&type=style&index=0&id=bc592c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc592c10",
  null
  
)

export default component.exports